import { atom } from "jotai";

/**
 * Conversation the [code]smith shell currently shows. Published from its
 * local selection state, which leads the URL: sidebar clicks repaint at
 * once and defer `router.push`, so `router.query.sessionPath` can still
 * name the previous conversation while this already names the new one.
 */
export const selectedCodesmithSessionIdAtom = atom<string | null>(null);
